var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandShake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.73,
    y: 67.92,
    width: 70.42,
    height: 21.79,
    transform: "translate(-39.85 65.94) rotate(-46.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.76,
    y: 66.46,
    width: 70.42,
    height: 21.79,
    transform: "translate(222.56 243.66) rotate(-136.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.65,68.69c12.64,10,27.23,4.86,27.23,4.86s36.94,30.87,37.43,35.73c0,0-2.67,10-10.69,11.43l-21.64-18c-18.71,12.88-33.06-3.89-33.06-3.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.16,105.64s2,19.44,17,32.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.69,157.17a13.47,13.47,0,0,1-7.77-8.75s15.49-17.74,41.2-40.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.5,123.57,60.26,163.49s.73,8.26,10.21,11.42l43-40.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.64,144.17l-38.1,36.58s-9-2.19-10.45-9.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.37,105.4s-8.65,14.88-19.68,30.87c-13,18.83-48.19,47.64-48.19,47.64s-6.26,0-10.15-8.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.5,75.74c.72-.24,18.47-8,18.47-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.22,177.41l10.15,6.5s7.59.3,10.27-8.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123,167.62l9.72,7.78s7.59-1.64,10.27-10.63l-9.79-8.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.69,163.49a13.64,13.64,0,0,0,10.7-10l-8.33-7.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.18,150.73s5.28-1.64,7-8.93l-7-7.11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandShake);
export default __webpack_public_path__ + "static/media/HAND_SHAKE.ec1a78357fd7fbbe8a1241445b2cb829.svg";
export { ForwardRef as ReactComponent };